//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/tags/views/main/lan/es';
import createEditTag from 'Modules/tags/.components/createEditTag/lan/es';
import deleteTag from 'Modules/tags/.components/deleteTag/lan/es';
import bulkTags from 'Modules/tags/.components/bulkTags/lan/es';

locales = { ...locales, ...main, ...createEditTag, ...deleteTag, ...bulkTags };


export default locales;